import React from 'react';

interface CrewVesselInfoFormProps {
  vesselName: string;
  onVesselNameChange: (value: string) => void;
  callSignAr: string;
  onCallSignChange: (value: string) => void;
  regNumber: string;
  onRegNumberChange: (value: string) => void;
  vesselLocationAr: string;
  onLocationChange: (value: string) => void;
  vesselFlagAr: string;
  onFlagChange: (value: string) => void;
}

const CrewVesselInfoForm: React.FC<CrewVesselInfoFormProps> = ({
  vesselName, onVesselNameChange,
  callSignAr, onCallSignChange,
  regNumber, onRegNumberChange,
  vesselLocationAr, onLocationChange,
  vesselFlagAr, onFlagChange,
}) => (
  <div className="card" dir="rtl">
    <div className="p-4 border-b border-gray-200">
      <h2 className="text-lg font-semibold text-gray-900">F.06.03.02 CREW LIST - بيانات المركب</h2>
    </div>
    <div className="p-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">اسم المركب</label>
          <input
            type="text"
            value={vesselName}
            onChange={(e) => onVesselNameChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
            placeholder="أدخل اسم المركب..."
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">رمز النداء</label>
          <input
            type="text"
            value={callSignAr}
            onChange={(e) => onCallSignChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
            placeholder="أدخل رمز النداء..."
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">رقم التسجيل</label>
          <input
            type="text"
            value={regNumber}
            onChange={(e) => onRegNumberChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
            placeholder="أدخل رقم التسجيل..."
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">الموقع</label>
          <input
            type="text"
            value={vesselLocationAr}
            onChange={(e) => onLocationChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
            placeholder="أدخل الموقع..."
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">العلم</label>
          <input
            type="text"
            value={vesselFlagAr}
            onChange={(e) => onFlagChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
            placeholder="أدخل العلم..."
          />
        </div>
      </div>
    </div>
  </div>
);

export default CrewVesselInfoForm;
